import { useEffect, useState } from 'react';
import { Alert, Box, IconButton, Paper, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AlertNotificationApiClient from '../../api/alertNotificationApiClient';
import { T, useTranslate } from '@tolgee/react';

const STORAGE_KEY = 'alm_shown_popup_ids';
const POLL_INTERVAL_MS = 10_000;

function PopupNotificationPoller() {
    const [visibleAlerts, setVisibleAlerts] = useState([]);
    const { t } = useTranslate();

    useEffect(() => {
        const poll = async () => {
            try {
                const { data: raw } = await AlertNotificationApiClient.getPendingPopups();
                const data = typeof raw === 'string' ? JSON.parse(raw) : raw;
                if (!Array.isArray(data) || data.length === 0) return;

                const shownIds = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
                const newAlerts = data.filter((a) => !shownIds.includes(a.id));
                if (newAlerts.length === 0) return;

                const updatedIds = [...shownIds, ...newAlerts.map((a) => a.id)];
                localStorage.setItem(STORAGE_KEY, JSON.stringify(updatedIds));

                setVisibleAlerts((prev) => [...prev, ...newAlerts]);
            } catch {
                // ignore network errors silently
            }
        };

        const initialDelay = setTimeout(poll, 2000);
        const interval = setInterval(poll, POLL_INTERVAL_MS);
        return () => {
            clearTimeout(initialDelay);
            clearInterval(interval);
        };
    }, []);

    const dismiss = (id) => {
        setVisibleAlerts((prev) => prev.filter((a) => a.id !== id));
    };

    if (visibleAlerts.length === 0) return null;

    return (
        <Box
            sx={{
                position: 'fixed',
                top: '24px',
                left: '50%',
                transform: 'translateX(-50%)',
                zIndex: 9999,
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                maxWidth: 520,
                width: '90%',
            }}
        >
            {visibleAlerts.map((alert) => (
                <Paper
                    key={alert.id}
                    elevation={8}
                    sx={{ borderRadius: 2, overflow: 'hidden' }}
                >
                    <Alert
                        severity="warning"
                        sx={{ alignItems: 'flex-start', py: 2, px: 2 }}
                        action={
                            <IconButton
                                size="small"
                                onClick={() => dismiss(alert.id)}
                            >
                                <CloseIcon fontSize="small" />
                            </IconButton>
                        }
                    >
                        <Typography variant="body2">
                            <T
                                keyName="popup-license-expiring"
                                defaultValue="We would like to inform you that the Youkey license package for the {companyName} customer is expiring soon."
                                params={{ companyName: <strong>{alert.companyName || t('popup-your-company', { defaultValue: 'your company' })}</strong> }}
                            />
                        </Typography>
                    </Alert>
                </Paper>
            ))}
        </Box>
    );
}

export default PopupNotificationPoller;
